module.exports = "/wp-content/themes/scdt/assets/images/icon-email.svg";